<section class="action-panel">
  <div class="action-panel__header">
    <div>
      <div class="action-panel__title">Select Facility</div>
      <div class="action-panel__subtitle">Search facilities by name or ID</div>
    </div>
    <span class="action-panel__count">{{ facilities?.length || 0 }} Total</span>
  </div>

  <mat-form-field appearance="outline" class="facility-search">
    <mat-label>Search facilities</mat-label>
    <input
      matInput
      type="text"
      placeholder="Search facilities by name or ID"
      [(ngModel)]="facilitySearchQuery" />
    <mat-icon matPrefix>search</mat-icon>
  </mat-form-field>

  <app-facility-list
    [facilities]="filteredFacilities"
    [selectedFacility]="selectedFacility"
    (facilityClick)="facilitySelected.emit($event)">
  </app-facility-list>
</section>
